import Vue from 'vue'
import VueMoment from 'vue-moment'
import 'vue-tel-input/dist/vue-tel-input.css'
import VeeValidate from 'vee-validate'

Vue.use(VueMoment)
Vue.use(VeeValidate)
